/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Teams_HeadingInputs */

const th_teams_heading = /** @type {(inputs: Teams_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทีม`)
};

const en_teams_heading = /** @type {(inputs: Teams_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teams`)
};

const ja_teams_heading = /** @type {(inputs: Teams_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チーム`)
};

const zh_teams_heading = /** @type {(inputs: Teams_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球队`)
};

const es_teams_heading = /** @type {(inputs: Teams_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equipos`)
};

const pt_teams_heading = /** @type {(inputs: Teams_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Times`)
};

const id_teams_heading = /** @type {(inputs: Teams_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tim`)
};

const fr_teams_heading = /** @type {(inputs: Teams_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Équipes`)
};

const tl_teams_heading = /** @type {(inputs: Teams_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga team`)
};

const vi_teams_heading = /** @type {(inputs: Teams_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đội`)
};

const ko_teams_heading = /** @type {(inputs: Teams_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`팀`)
};

const de_teams_heading = /** @type {(inputs: Teams_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teams`)
};

const ru_teams_heading = /** @type {(inputs: Teams_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Команды`)
};

const tr_teams_heading = /** @type {(inputs: Teams_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Takımlar`)
};

const it_teams_heading = /** @type {(inputs: Teams_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Squadre`)
};

const pl_teams_heading = /** @type {(inputs: Teams_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drużyny`)
};

const uk_teams_heading = /** @type {(inputs: Teams_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Команди`)
};

const hi_teams_heading = /** @type {(inputs: Teams_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टीमें`)
};

const ar_teams_heading = /** @type {(inputs: Teams_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الفرق`)
};

const ms_teams_heading = /** @type {(inputs: Teams_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasukan`)
};

const bn_teams_heading = /** @type {(inputs: Teams_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`দল`)
};

const zh_tw2_teams_heading = /** @type {(inputs: Teams_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球隊`)
};

const zh_hk2_teams_heading = /** @type {(inputs: Teams_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球隊`)
};

const ur_teams_heading = /** @type {(inputs: Teams_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ٹیمیں`)
};

const fa_teams_heading = /** @type {(inputs: Teams_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تیم‌ها`)
};

const sw_teams_heading = /** @type {(inputs: Teams_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timu`)
};

const nl_teams_heading = /** @type {(inputs: Teams_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teams`)
};

/**
* | output |
* | --- |
* | "Teams" |
*
* @param {Teams_HeadingInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const teams_heading = /** @type {((inputs?: Teams_HeadingInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teams_HeadingInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_teams_heading(inputs)
	if (locale === "ja") return ja_teams_heading(inputs)
	if (locale === "zh") return zh_teams_heading(inputs)
	if (locale === "es") return es_teams_heading(inputs)
	if (locale === "pt") return pt_teams_heading(inputs)
	if (locale === "id") return id_teams_heading(inputs)
	if (locale === "fr") return fr_teams_heading(inputs)
	if (locale === "tl") return tl_teams_heading(inputs)
	if (locale === "vi") return vi_teams_heading(inputs)
	if (locale === "ko") return ko_teams_heading(inputs)
	if (locale === "de") return de_teams_heading(inputs)
	if (locale === "ru") return ru_teams_heading(inputs)
	if (locale === "tr") return tr_teams_heading(inputs)
	if (locale === "it") return it_teams_heading(inputs)
	if (locale === "pl") return pl_teams_heading(inputs)
	if (locale === "uk") return uk_teams_heading(inputs)
	if (locale === "hi") return hi_teams_heading(inputs)
	if (locale === "ar") return ar_teams_heading(inputs)
	if (locale === "ms") return ms_teams_heading(inputs)
	if (locale === "bn") return bn_teams_heading(inputs)
	if (locale === "zh-TW") return zh_tw2_teams_heading(inputs)
	if (locale === "zh-HK") return zh_hk2_teams_heading(inputs)
	if (locale === "ur") return ur_teams_heading(inputs)
	if (locale === "fa") return fa_teams_heading(inputs)
	if (locale === "sw") return sw_teams_heading(inputs)
	if (locale === "nl") return nl_teams_heading(inputs)
	return en_teams_heading(inputs)
});